import React from "react";
import TitlePage from "../../../app/Title/TitlePage/TitlePageView";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import {Button} from "primereact/button";
import {Divider} from "@material-ui/core";
import NumberFormat from "react-number-format";
import {InputText} from "primereact/inputtext";
import {price} from "../../../utils/formatters/Numbers";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";

const SplitView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{
                       paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%',
                       overflow: 'auto'
                   }}>
                {props.messagesGrowl}
                <Grid container spacing={1}>
                    <div className="p-col-8" align="right">
                        <TitlePage title={props.screenName}/>
                    </div>
                    <div className="p-col-4" align="right">
                        <Button label="Cancelar" className="p-button-secondary"
                                onClick={props.returnCorporateActionPage}/>&nbsp;
                        <Button label="Guardar" onClick={props.applyCorporateAction}/>
                    </div>
                    <div className="p-col-12"> <Divider/> </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Emisora" isBold={true}/>
                        <SubtitleLabel header={props.dataCorporateAction.fullInstrument}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Precio" isBold={true}/>
                        <SubtitleLabel header={props.dataCorporateAction.precio24Hrs ?
                            price(props.dataCorporateAction.precio24Hrs.toFixed(6), "left", " ") :
                            '0.0'}/>
                    </div>
                    <div className="p-col-12">
                        <SubtitleLabel header="Descripción" isBold={true}/>
                        <SubtitleLabel header={props.dataCorporateAction.descrCorporateAction}/>
                    </div>
                    <div className="p-col-6">
                        <SubtitleLabel header="Ratio" isBold={true}/>
                        <NumberFormat decimalScale={2}
                                      id={3} name="ratio"
                                      required={true}
                                      value={props.ratio}
                                      onChange={props.handleChangeValue}
                                      customInput={InputText}/>
                    </div>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default SplitView;